module.exports = __webpack_public_path__ + "img/CUPOM.be4d05d7.png";